/** Menu type constants to eliminate string repetition */
export const MENU_TYPES = {
  FULLPATH: "fullpath",
  EPAPER: "epaper",
  URL: "url",
  WORD_QUIZ: "word-quiz",
  MENU: "menu",
} as const;

/** Base URL for local public icons */
export const ICON_BASE = "/web2-assets/app/menu";
export const ICON_EXTENSION = ".png";

export const ICONS = {
  TODAY: "today",
  SINGAPORE: "singapore",
  TAMIL_NADU: "tamilnadu",
  EPAPER: "epaper",
  COMMUNITY: "community",
  WORLD: "world",
  INDIA: "india",
  TABLA: "tabla",
  SPORTS: "sports",
  LIFESTYLE: "lifestyle",
  ALL: "all",
  BALAR_MURASU: "balar-murasu",
  WORD_QUIZ: "quiz",
  WORD_QUIZ_SECTION: "quiz-section", // submenu variant icon
  MANAVAR_MURASU: "manavar-murasu",
} as const;

/** Centralized color palette for consistent theming */
export const MENU_COLORS = {
  // Primary brand colors
  PRIMARY: "#B00241",

  // Section-specific colors
  TODAY: "#F5740A",
  SINGAPORE: "#C30248",
  TAMIL_NADU: "#7D00B7",
  EPAPER: "#641D70",
  COMMUNITY: "#F16095",
  WORLD: "#4B6AAE",
  INDIA: "#FAAC43",
  TABLA: "#4B6AAE",
  SPORTS: "#449DD6",
  LIFESTYLE: "#FF1075",
  WORD_QUIZ: "#FAAC43",
  SUBSECTION: "#FAFAFA",
} as const;

/** External URLs for external menu items */
const BASE_URL = "https://www.tamilmurasu.com.sg";
const MOBILE_SUFFIX = "?mobwebview=true";

export const EXTERNAL_URLS = {
  BALAR_MURASU: `${BASE_URL}/balar-murasu${MOBILE_SUFFIX}`,
  MANAVAR_MURASU: `${BASE_URL}/maanavar-murasu${MOBILE_SUFFIX}`,
  JOBS: `${BASE_URL}/jobs${MOBILE_SUFFIX}`,
} as const;

/** Feed URL patterns for consistent construction */
export const FEED_PATTERNS = {
  HOME: "context.json",
  // The SECTION_SUFFIX is appended to section name to form the full feed URL
  // Example usage: buildSectionFeed("singapore") produces "singapore/context.json"
  SECTION_SUFFIX: "/context.json",
  WORD_QUIZ: "_plat/api/v1/feed/special_section/word-quiz",
  EPAPER: "epaper",
} as const;

/** Section names for consistent usage (Tamil and English) */
export const SUBSECTION_NAMES = {
  SINGAPORE: "சிங்க‌ப்பூர்",
  TAMIL_NADU: "தமிழ்நாடு",
  COMMUNITY: "சமூகம்",
  WORLD: "உல‌க‌ம்",
  INDIA: "இந்தியா",
  TABLA: "Tabla",
  SPORTS: "விளையாட்டு",
  LIFESTYLE: "வாழ்வும் வளமும்",
  CINEMA: "திரைச்செய்தி",
  YOUTH: "இளையர் முரசு",
  PHOTO_GALLERY: "படச் செய்திகள்",
  SPECIAL_FEATURE: "சிறப்புக் கட்டுரை",
  LITERATURE: "கதை/கவிதை",
  EPAPER: "இ-பேப்பர்",
  WORD_QUIZ: "முரசு சொல்லாட்டம்",
  JOBS: "வேலைகள்",
  BALAR_MURASU: "Balar Murasu",
  MANAVAR_MURASU: "Manavar Murasu",
} as const;

export const SECTION_IDENTIFIERS = {
  SINGAPORE: "singapore",
  TAMIL_NADU: "tamilnadu",
  INDIA: "india",
  WORLD: "world",
  COMMUNITY: "community",
  SPORTS: "sports",
  LIFESTYLE: "lifestyle",
  CINEMA: "cinema",
  YOUTH: "youth",
  PHOTO_GALLERY: "photo-gallery",
  SPECIAL_FEATURE: "special-feature",
  LITERATURE: "literature",
  TABLA: "tabla",
  WORD_QUIZ: "word-quiz",
  TM_PICKS: "tm-picks",
} as const;

/** Menu codes for consistent identification */
export const MENU_CODES = {
  TODAY: "Today",
  SINGAPORE: "Singapore",
  TAMIL_NADU: "TamilNadu",
  EPAPER: "ePaper",
  COMMUNITY: "Community",
  WORLD: "World",
  INDIA: "India",
  WORD_QUIZ: "WordQuiz",
  TABLA: "Tabla",
  SPORTS: "Sports",
  LIFESTYLE: "Lifestyle",
  ALL: "All",
} as const;

/** Submenu codes for the "All Categories" menu */
const prefix = "All/";

// Helper function to reduce repetition
const createSubCode = (name: string) => `${prefix}${name}`;

export const SUB_ALL_CODES = {
  SINGAPORE: createSubCode("Singapore"),
  TAMIL_NADU: createSubCode("TamilNadu"),
  COMMUNITY: createSubCode("Community"),
  WORLD: createSubCode("World"),
  INDIA: createSubCode("India"),
  TABLA: createSubCode("Tabla"),
  CINEMA: createSubCode("Cinema"),
  SPORTS: createSubCode("Sports"),
  LIFESTYLE: createSubCode("Lifestyle"),
  YOUTH: createSubCode("Youth"),
  PHOTO_GALLERY: createSubCode("PhotoGallery"),
  SPECIAL_FEATURE: createSubCode("SpecialFeature"),
  LITERATURE: createSubCode("Literature"),
  EPAPER: createSubCode("ePaper"),
  BALAR: createSubCode("Balar Murasu"),
  MAANAVAR: createSubCode("Manavar Murasu"),
  JOBS: createSubCode("Jobs"),
  WORD_QUIZ: createSubCode("WordQuiz"),
} as const;

/** Menu labels mapping */
export const MENU_LABELS = {
  TODAY: "Today",
  SINGAPORE: "Singapore",
  TAMIL_NADU: "Tamil Nadu",
  EPAPER: "ePaper",
  COMMUNITY: "Community",
  WORLD: "World",
  INDIA: "India",
  TABLA: "Tabla",
  SPORTS: "Sports",
  LIFESTYLE: "Lifestyle",
  ALL: "All Categories",
  WORD_QUIZ: "Word Quiz",
} as const;
